Object.defineProperty(exports,"__esModule",{value:true});var _UnimplementedView=require('../UnimplementedView');var _UnimplementedView2=_interopRequireDefault(_UnimplementedView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_UnimplementedView2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/components/FlatList/index.js
 ** module id = 828
 ** module chunks = 0
 **/